import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["check", "confettiTemplate"];
  static values = { url: String };

  connect() {
    this.animations = [];
    this.motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.onMotionChange = () => this.clearConfetti();
    this.motionQuery.addEventListener("change", this.onMotionChange);
    this.openObserver = new MutationObserver(() => {
      this.clearConfetti();
      if (this.element.open) this.celebrate();
    });
    this.openObserver.observe(this.element, { attributes: true, attributeFilter: ["open"] });
    if (this.element.open) this.celebrate();
  }

  disconnect() {
    this.openObserver.disconnect();
    this.motionQuery.removeEventListener("change", this.onMotionChange);
    this.clearConfetti();
  }

  celebrate() {
    if (this.motionQuery.matches) return;

    for (let index = 0; index < 32; index += 1) {
      const particle = this.confettiTemplateTarget.content.firstElementChild.cloneNode(true);
      this.checkTarget.append(particle);
      const x = (Math.random() - 0.5) * 320;
      const rise = -30 - Math.random() * 70;
      const rotation = Math.random() * 720 - 360;
      const animation = particle.animate([
        { transform: "translate(-50%, -50%) scale(0)", opacity: 1 },
        { transform: `translate(${x * 0.65}px, ${rise}px) rotate(${rotation / 2}deg)`, opacity: 1, offset: 0.35 },
        { transform: `translate(${x}px, ${100 + Math.random() * 100}px) rotate(${rotation}deg)`, opacity: 0 },
      ], { duration: 1100 + Math.random() * 300, easing: "ease-out" });
      this.animations.push(animation);
      animation.finished.then(() => particle.remove()).catch(() => {});
    }
  }

  clearConfetti() {
    this.animations.forEach((animation) => { animation.cancel(); animation.effect?.target?.remove(); });
    this.animations = [];
  }

  urlValueChanged() {
    const parameters = { facebook: "u", linkedin: "url", whatsapp: "text", email: "body" };
    this.element.querySelectorAll("[data-share-platform]").forEach((link) => {
      const parameter = parameters[link.dataset.sharePlatform];
      if (!parameter) return;
      const url = new URL(link.href);
      url.searchParams.set(parameter, this.urlValue);
      link.href = url.toString();
    });
  }

  close() {
    this.element.close();
  }

  copyForPlatform() {
    const copyElement = this.element.querySelector('[data-controller~="share-link"]');
    const controller = this.application.getControllerForElementAndIdentifier(copyElement, "share-link");
    if (!controller) return;

    controller.urlValue = this.urlValue;
    return controller.copy();
  }
}
